import { cn } from "@/lib/utils";

interface FieldGroupHeaderProps {
  group: string;
  hasTopBorder: boolean;
}

const FieldGroupHeader = ({ group, hasTopBorder }: FieldGroupHeaderProps) => (
  <li
    role="presentation"
    data-group-name={group}
    data-group-role="header"
    className={cn(
      "px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-400",
      hasTopBorder && "mt-0.5 border-t border-gray-100 pt-1.5",
    )}
  >
    {group}
  </li>
);

export default FieldGroupHeader;
